import { UseFormReturn } from "react-hook-form";
import Applicants from "@/model/interface/form/Applicants";
import ApiApplicationApplicant from "@/model/interface/api/ApiApplicationApplicant";
import React from "react";
import { Pencil } from "lucide-react";

const ApplicantCurrentMortgage = ({
  form,
  applicant,
  applicantType,
}: {
  form: UseFormReturn<Applicants>;
  applicant: ApiApplicationApplicant;
  applicantType: "mainApplicant" | "coApplicant";
}) => {
  const { register, formState } = form;

  return (
    <div className="space-y-5">
      <div className="relative">
        <h6 className="text-sm text-gray-500 mb-1">Who is the current mortgage held with</h6>
        <input
          type="text"
          {...register(`${applicantType}.mortgageHeldWith`, { value: applicant?.mortgageHeldWith })}
          className={`w-full h-11 rounded-lg border bg-white px-4 pr-10 text-sm outline-none transition-colors focus:border-[#0FD131] focus:ring-2 focus:ring-[#9BFBE0] ${formState.errors[applicantType]?.mortgageHeldWith ? "border-red-400" : "border-gray-300"}`}
          placeholder="Bank name"
        />
        <Pencil className="absolute right-3 top-9 size-3.5 text-gray-400 pointer-events-none" />
        {formState.errors[applicantType]?.mortgageHeldWith && (
          <p className="mt-1 text-sm text-red-500">{formState.errors[applicantType]?.mortgageHeldWith?.message}</p>
        )}
      </div>
    </div>
  );
};

export default ApplicantCurrentMortgage;
